import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import Sidebar from '../Sidebar'


class BlogItem extends Component {
	render() {
		return (
			<div>
				<Header
					bg="none"
					image={require('./image.jpg')}
					title={"Using Email as a Marketing Tool in 2020"}
				/>
				<div className="entry-content">
					
					<div className="container">
						<h2 className="blog-details">
								<div className="author-circle lauren"></div>
								<div className="line"></div>
								<div className="title">
									Written by <strong>Lauren</strong> on 10 June 2020  //  Posted in <strong>Marketing</strong>
								</div>
						</h2>
						
						<div className="row">
							<div className="col-lg-7">
								<div className="tagline">
									Using Email as a Marketing Tool in 2020
								</div>
								

<h3>Email is <b>STILL</b> one of the most efficient and cost-effective ways to market to your customers. </h3> 
<p> It’s easy to set up, and in most cases, is a free function when creating a website.</p> 

<br></br>
<p>Having an email database is essentially providing you with a list of people interested in your product or offering. <a href="https://www.moshi.com.au/whatwedo/email-newsletter-marketing">Email marketing</a> is a very effective long-term business investment with a much higher return - people will continue to receive your message at a very low cost for a longer period of time than other marketing methods.</p>

<p>Sending regular communications to your email database (we recommend using an email automation system like <a href="https://www.moshi.com.au/website-development">Mailchimp</a>) is an easy way to keep your business in their mind, which creates a higher likelihood of converting into paying customers. </p>
<br></br>
<hr></hr>
<br></br>
<h2>Email Signups are Easy to Set Up (and are Usually Free!)</h2>
<p>Most website platforms include some form of email option for you to include in your design. If you have a <a href="https://www.moshi.com.au/whatwedo/website-development  ">custom site</a>, your developer should also be able to include one very easily. </p>

<br></br>
<hr></hr>
<br></br>
<h2>Send Messages Directly to People Who Are Interested</h2>
<p>In order to join your email list, people have to opt-in. This means they’ve entered their details, and then confirmed that they want to be contacted. </p>
<p>When you send an email out, that message appears directly in their inbox. There’s no competition for higher placements or better spots like in other marketing methods (say, if you were advertising on <a href="https://www.moshi.com.au/whatwedo/google-advertising">Google</a>).</p>

<br></br>
<hr></hr>
<br></br>
<h2>Create Relationships and Strengthen Brand Loyalty</h2>
<p>Because you know these people are interested in you, you can personalise offerings to them to incentivise them to convert. </p>
<p>For example, a lot of companies give discounts, sneak peeks or exclusive deals to their email database to be used in-store or online, creating a relationship between brand and customer. </p>


<br></br>
<hr></hr>
<br></br>
<h2>An Easy Way to Keep Your Customers Informed</h2>
<p>Email is still the easiest method for time poor business owners to alert their customers of new products, new hours, a new address, and any special sales or deals that are happening.</p>
<p>Some email services will even auto-populate your email <i>for</i> you, pulling any new information from your site directly through to your outgoing email template.</p>



<br></br>
<hr></hr>
<br></br>
<h2>Use Your Email Opens to Analyse Who Your Actual Customers Are</h2>
<p>If you have a large email database, it is definitely worth using an automated email service. Once you have your email lists imported into your database, you will be able to start analysing the data given to you. This includes email opens (how many people opened/who opened), and statistics on who clicked through links from your email.</p>
<p>Having this data at your fingertips allows you to see the demographic of people who are actually interacting and engaging with your email content, meaning you can cater content to appeal more to these sorts of customers.</p>

<h3>Don’t be disappointed by the amount of people who didn’t open your emails.</h3>

<p>Even if they weren’t opened, your email and your business name were directly in their eyeline - this in itself is what a lot of companies aim for by using PPC advertising.</p>

<br></br>
<hr></hr>
<br></br>
<h2>Segment Your Email List into Smaller Audiences</h2>
<p>Having a large email database also gives you the ability to segment your audience into different groups. For example, you may want to change your message to previous customers, VIP customers and new customers.</p>
<p>This allows you to create curated content to each niche of your online audience.</p>

<br></br>
<hr></hr>
<br></br>
<h2>Use Your Email List to Create a Lookalike Audience on Facebook</h2>
<p>Always, <b>ALWAYS</b> make sure you have segmented your regular email subscribers (obtained via your website) from your social media acquired subscribers before you complete this step!</p>
<p>Lookalike audiences are Facebook generated lists of users who resemble the audience you upload to your Facebook Audience - providing you with a new targeted audience more likely to convert.</p>
<p>To create this list, first download your existing list into a .CSV file (most email databases have the option to do this). Once done, head to your Facebook Business Manager, head to ‘Ads Manager’, and ‘Audience’. From there, select ‘Create Audience’, then ‘Custom Audience’. </p>
<p>Once in the ‘Custom Audience’ area, either upload your CSV, or import it from your email service provider (if you could not download in the CSV format).</p>

<p>This has now given your data to Facebook. The next step is to map ‘identifiers’ in your email list that will help the Facebook algorithm create a lookalike audience. The more identifiers you have, the more targeted your lookalike audience will be.</p>

<p>Once done, click Upload and Create. You will then see a progress bar showing you the steps you’ve already covered. Click on Next Steps. Under that, select Create a Lookalike Audience.</p>

<br></br>
<hr></hr>
<p>If you’re interested in setting up a regular outgoing email to your audience, or need help creating your Lookalike Audience, <a href="https://www.moshi.com.au/contact-us">get in touch</a> with our Moshi team. We’re always happy to help you with your marketing.</p> 




							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-4">
								<Sidebar />
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default BlogItem;


// WEBPACK FOOTER //
// ./src/Pages/Blog/Email2020/index.js